import { render, staticRenderFns } from "./sex.vue?vue&type=template&id=28d72a97&scoped=true"
import script from "./sex.vue?vue&type=script&lang=js"
export * from "./sex.vue?vue&type=script&lang=js"
import style0 from "./sex.vue?vue&type=style&index=0&id=28d72a97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d72a97",
  null
  
)

export default component.exports